import { render, staticRenderFns } from "./EditReadme.vue?vue&type=template&id=410f4b31&"
import script from "./EditReadme.vue?vue&type=script&lang=js&"
export * from "./EditReadme.vue?vue&type=script&lang=js&"
import style0 from "./EditReadme.vue?vue&type=style&index=0&id=410f4b31&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports